import { useEffect, useState, type JSX } from 'react';

import { Logos, LogoType } from './constants';
import { LogoProps, SVGDynamicImport } from './types';

interface PaymentLogoProps extends LogoProps {
	name: string;
	type?: LogoType;
	fallback?: JSX.Element;
}

const PaymentLogos = ({ name, type = LogoType.colored, fallback, ...rest }: PaymentLogoProps) => {
	const [importedIcon, setImportedIcon] = useState<JSX.Element | null>(null);
	const logoType = name
		.toLowerCase()
		.replaceAll(' ', '')
		.normalize('NFD')
		.replace(/[\u0300-\u036f]|-/g, '') as keyof typeof Logos;

	const logo = Logos[logoType];

	useEffect(() => {
		const importComponent = async () => {
			try {
				const module = await (import(`./svgs/${logo}`) as SVGDynamicImport);
				const SVG = module[type] ?? module.default;

				setImportedIcon(<SVG className="icon__payments icon--sprite" {...rest} />);
			} catch (_) {
				if (fallback) {
					setImportedIcon(fallback);
					return;
				}

				const module = await (import(`./svgs/${Logos.default}`) as SVGDynamicImport);
				const SVG = module[type] ?? module.default;

				setImportedIcon(<SVG className="icon__payments icon--sprite" {...rest} />);
			}
		};

		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		importComponent();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [name]);

	return importedIcon;
};

export default PaymentLogos;
